import '../scss/favourite-brand.scss';

interface Props {
  handleAddMoreClick: () => void;
}

const FavouriteBrandAddMore: React.FC<Props> = ({ handleAddMoreClick }) => {
  return (
    <section className="favourite-brand text-center">
      <div onClick={() => handleAddMoreClick()}>
        <div className="favourite-brand__image-placeholder favourite-brand__image-placeholder--add-more mb-2"></div>

        <p className="mb-0 fz-14 font-yettel">Dodaj još brendova</p>
      </div>
    </section>
  );
};

export default FavouriteBrandAddMore;
